import i18next from "i18next";
import { useNavigate } from "react-router";
import Button from "../../components/Button";
import Label from "../../components/Label";
import SimpleDialog from "../../components/SimpleDialog";

export default function NotFound() {
	const navigate = useNavigate();

	const goBack = () => navigate(-1);

	const handleLogout = async () => {
		navigate("/");
	};

	return (
		<SimpleDialog open={true} onClose={goBack}>
			<Label text={i18next.t("error-not-found")}></Label>

			<div className="d-flex mt-4 justify-content-end">
				<Button
					label={i18next.t("accept")}
					onClick={handleLogout}
					className="ms-4"
					datatestid={"logout-accept"}
				/>
			</div>
		</SimpleDialog>
	);
}
